// اضافات/کسورات نوع قرارداد
// به‌صورت مودال از داخل «انواع قراردادها» باز می‌شود.
import React, { useState, useEffect, useCallback } from 'react';
import { ui } from '../../components/ListPage';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const fmtP = n => (n || n === 0 ? toFa(n) + '٪' : '•');

const API = (path, opts = {}) => fetch(`/api/contract${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

const EMPTY = { mode: 'addition', addition_id: 0, addition: '', deduction_id: 0, deduction: '',
  gov_percent: '', contractor_percent: '', if_final: false };

function Lookup({ label, value, endpoint, onPick }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => {
    setQ(text);
    const j = await API(`${endpoint}?q=${encodeURIComponent(text)}`);
    if (j.ok) { setRows(j.rows); setOpen(true); }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => search(q)} onChange={e => search(e.target.value)}
        placeholder="جستجو..." style={ui.input} />
      {value && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 1200, maxHeight: '220px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>{r.display}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function ContractTypeAdditionDeduction({ typeId, typeTitle, onClose }) {
  // مجوز دکمه‌های فرم FRMCONTRACTTYPEADDITIONDEDUCTION — دیدن = دسترسی
  const vbf = useFormButtons('FRMCONTRACTTYPEADDITIONDEDUCTION', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK"]);
  const [data, setData]         = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState(EMPTY);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [toast, setToast]       = useState('');

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 2500); };

  const load = useCallback(async () => {
    setLoading(true); setError(''); setSelected(null);
    const j = await API(`/contract-types/${typeId}/addition-deduction/`);
    setLoading(false);
    if (j.ok) setData(j.data); else setError(j.msg);
  }, [typeId]);

  useEffect(() => { load(); }, [load]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew  = () => { if (!vbf.can('BTNNEW')) return; setForm(EMPTY); setError(''); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setForm({
      mode: selected.addition_id > 0 ? 'addition' : 'deduction',
      addition_id: selected.addition_id, addition: selected.addition_title,
      deduction_id: selected.deduction_id, deduction: selected.deduction_title,
      gov_percent: selected.gov_percent || '', contractor_percent: selected.contractor_percent || '',
      if_final: selected.if_final,
    });
    setError(''); setModal('edit');
  };
  const openDel = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  const save = async () => {
    setSaving(true); setError('');
    // بر اساس حالت، فقط اضافات یا کسورات ارسال می‌شود (متقابل)
    const body = form.mode === 'addition'
      ? { addition_id: form.addition_id, deduction_id: 0, gov_percent: form.gov_percent, contractor_percent: 0, if_final: form.if_final }
      : { addition_id: 0, deduction_id: form.deduction_id, gov_percent: 0, contractor_percent: form.contractor_percent, if_final: form.if_final };
    const j = modal === 'new'
      ? await API(`/contract-types/${typeId}/addition-deduction/create/`, { method: 'POST', body: JSON.stringify(body) })
      : await API(`/contract-types/${typeId}/addition-deduction/${selected.id}/update/`, { method: 'PUT', body: JSON.stringify(body) });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/contract-types/${typeId}/addition-deduction/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(); }
    else { setError(j.msg); setModal(null); }
  };

  return (
    <div style={ui.overlay} onClick={onClose}>
      <div style={{ ...ui.modal, maxWidth: '1000px', width: '96%', height: '86vh' }} onClick={e => e.stopPropagation()}>
        <div style={ui.mHeader}>
          <div style={ui.mTitle}>اضافات و کسورات — {typeTitle}</div>
          <button onClick={onClose} style={ui.closeBtn}>✕</button>
        </div>

        <div style={{ display: 'flex', gap: '8px', padding: '12px 18px', borderBottom: '1px solid #f0f2f7', flexWrap: 'wrap' }}>
          {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
          {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
          {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
          {loading && <span style={{ alignSelf: 'center' }}>⏳</span>}
          {!loading && <div style={{ ...ui.countBadge, alignSelf: 'center' }}>{toFa(data.length)} مورد</div>}
        </div>

        {error && !modal && <div style={{ ...ui.errBox, margin: '10px 18px' }}>⚠️ {error}</div>}

        <div style={{ flex: 1, overflowY: 'auto', margin: '0 18px 12px', borderRadius: '10px', border: '1px solid #eee' }}>
          <table style={{ ...ui.table, tableLayout: 'auto' }}>
            <thead style={{ position: 'sticky', top: 0, zIndex: 5 }}>
              <tr>
                {['نوع', 'عنوان اضافات', 'عنوان کسورات', 'درصد سهم دولت', 'درصد سهم پیمانکار', 'نوع اضافات', 'نوع کسورات', 'نوع سایر کسورات', 'گیرنده کسور', 'توضیح'].map((h, i) => (
                  <th key={i} style={ui.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((r, i) => {
                const sel = selected?.id === r.id;
                const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf6e3';
                const tc  = sel ? '#fff' : '#111';
                const isAdd = r.addition_id > 0;
                return (
                  <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                    onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                    onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                    onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                    <td style={{ ...ui.td, color: sel ? '#fff' : isAdd ? '#1b5e20' : '#b71c1c', fontWeight: '700' }}>{isAdd ? 'اضافات' : 'کسورات'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.addition_title || '•'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.deduction_title || '•'}</td>
                    <td style={{ ...ui.tdNum, color: sel ? '#fff' : '#1b5e20' }}>{isAdd ? fmtP(r.gov_percent) : '•'}</td>
                    <td style={{ ...ui.tdNum, color: sel ? '#fff' : '#b71c1c' }}>{!isAdd ? fmtP(r.contractor_percent) : '•'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.addition_kind || '•'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.deduction_kind || '•'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.other_deduction_kind || '•'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.receiver || '•'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: tc }}>{r.if_final ? 'فقط برای صورت وضعیت قطعی' : '•'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!loading && data.length === 0 && <div style={ui.empty}>📭 موردی ثبت نشده است</div>}
        </div>
      </div>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '560px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ اضافات/کسورات جدید' : '✎ ویرایش'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}
              <div style={ui.row}>
                <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', color: '#1b5e20' }}>
                    <input type="radio" name="admode" checked={form.mode === 'addition'}
                      onChange={() => setForm(f => ({ ...f, mode: 'addition', deduction_id: 0, deduction: '' }))} />
                    اضافات (سهم دولت)
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', color: '#b71c1c' }}>
                    <input type="radio" name="admode" checked={form.mode === 'deduction'}
                      onChange={() => setForm(f => ({ ...f, mode: 'deduction', addition_id: 0, addition: '' }))} />
                    کسورات (سهم پیمانکار)
                  </label>
                </div>
              </div>
              {form.mode === 'addition' ? (
                <div style={ui.row}>
                  <Lookup label="عنوان اضافات" value={form.addition} endpoint="/contract-types/lookup/addition/"
                    onPick={r => setForm(f => ({ ...f, addition_id: r.id, addition: r.display }))} />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '150px' }}>
                    <label style={ui.mlabel}>درصد سهم دولت</label>
                    <input type="number" value={form.gov_percent} onChange={e => F('gov_percent', e.target.value)} style={ui.input} />
                  </div>
                </div>
              ) : (
                <div style={ui.row}>
                  <Lookup label="عنوان کسورات" value={form.deduction} endpoint="/contract-types/lookup/deduction/"
                    onPick={r => setForm(f => ({ ...f, deduction_id: r.id, deduction: r.display }))} />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '150px' }}>
                    <label style={ui.mlabel}>درصد سهم پیمانکار</label>
                    <input type="number" value={form.contractor_percent} onChange={e => F('contractor_percent', e.target.value)} style={ui.input} />
                  </div>
                </div>
              )}
              <div style={ui.row}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                  <input type="checkbox" checked={form.if_final} onChange={e => F('if_final', e.target.checked)} style={{ width: '18px', height: '18px' }} />
                  فقط برای صورت وضعیت قطعی
                </label>
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '420px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '24px' }}>
              <div style={{ fontSize: '30px', marginBottom: '8px' }}>🗑️</div>
              {selected?.addition_id > 0 ? selected?.addition_title : selected?.deduction_title}
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </div>
  );
}
